const messageBody = (msg) => (msg.streamingText ?? msg.content).trim();
const formatSection = (title, body, extra) => {
    const lines = [`## ${title}`, ''];
    if (extra) {
        lines.push(extra, '');
    }
    lines.push('```', body || '(empty)', '```', '');
    return lines.join('\n');
};
export const buildConversationExport = (eventId, threadTitle, threadId, messages) => {
    const sorted = [...messages].sort((a, b) => a.orderIndex - b.orderIndex);
    const header = [
        '# Agent conversation export',
        '',
        `- Event: ${eventId}`,
        `- Thread: ${threadTitle ?? '(unsaved)'}`,
        `- Thread ID: ${threadId ?? '(new)'}`,
        `- Exported: ${new Date().toISOString()}`,
        `- Messages: ${sorted.length}`,
        '',
        'Raw stored content per message (UI grouping/rendering not applied).',
        '',
        '---',
        '',
    ].join('\n');
    const sections = sorted.map((msg, index) => {
        const body = messageBody(msg);
        const meta = msg.metadataJson?.trim();
        switch (msg.kind) {
            case 'User':
                return formatSection(`[${index + 1}] User`, body, `id: ${msg.id}`);
            case 'Assistant':
                return formatSection(`[${index + 1}] Assistant (finish / visible)`, body, `id: ${msg.id}`);
            case 'Thinking': {
                let extra = `id: ${msg.id}`;
                if (meta)
                    extra += `\nmetadata: ${meta}`;
                return formatSection(`[${index + 1}] Stage (Thinking)`, body, extra);
            }
            case 'ToolCall': {
                let extra = `id: ${msg.id}\ntool: ${msg.content}`;
                if (meta)
                    extra += `\nmetadata: ${meta}`;
                const argsBody = meta ?? body;
                return formatSection(`[${index + 1}] ToolCall`, argsBody, extra);
            }
            case 'ToolResult': {
                let extra = `id: ${msg.id}`;
                if (meta)
                    extra += `\nmetadata: ${meta}`;
                return formatSection(`[${index + 1}] ToolResult`, body, extra);
            }
            case 'Error': {
                let extra = `id: ${msg.id}`;
                if (meta)
                    extra += `\nmetadata: ${meta}`;
                return formatSection(`[${index + 1}] Error`, body, extra);
            }
            default:
                return formatSection(`[${index + 1}] ${msg.kind}`, body, `id: ${msg.id}`);
        }
    });
    return header + sections.join('\n');
};
export const downloadTextFile = (filename, content) => {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    URL.revokeObjectURL(url);
};
